import { render, staticRenderFns } from "./StudyFooter.vue?vue&type=template&id=0babcf82&scoped=true"
import script from "./StudyFooter.vue?vue&type=script&lang=js"
export * from "./StudyFooter.vue?vue&type=script&lang=js"
import style0 from "./StudyFooter.vue?vue&type=style&index=0&id=0babcf82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0babcf82",
  null
  
)

export default component.exports